import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import closeBtn from "../../include/media/close.svg";
import { connect } from "react-redux";

class CancelAppointment extends Component {

  render() {
    return (
      <div className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
          <div className="modal-content">
            <Modal
              {...this.props}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <div className="modal-header">
                <h3>Cancel Appointment</h3>
                <button
                  type="button"
                  className="close mt-2"
                  data-dismiss="modal"
                  onClick={this.props.onHide}
                >
                  <img src={closeBtn} alt="close popup" />
                </button>
              </div>

              <div className="modal-body">
                <div className="modal-alert-box text-center">
                  <p style={{ fontSize: 15, fontWeight: 500 }}>
                    Are you sure you want to cancel this appointment?
                  </p>
                </div>

                <div className="modal-action-btn">
                  <button
                    type="button"
                    className="btn btn-delete"
                    onClick={() => this.props.handleCancel(this.props.cancel_id)}
                  >
                    Yes
                  </button>

                  <a
                    href="javascript:void(0)"
                    onClick={this.props.onHide}
                    className="btn btn-cancel"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    No
                  </a>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(CancelAppointment);